<div
  class="h-full w-full grow basis-0 overflow-y-auto md:mt-0 md:w-auto md:px-8 md:pb-8"
  #scrollContainer
  (scroll)="onScroll()">
  @if (messages.length === 0) {
    <app-no-messages />
  } @else {
    <app-scroll-indicator [show]="showScrollIndicator" />
    @for (message of messages; let i = $index; track message.timestamp + message.content) {
      <app-message-bubble
        [subtype]="message.subtype"
        [type]="message.type"
        [content]="message.content"
        [sender]="message.sender"
        [timestamp]="message.timestamp"
        [variant]="getMessageVariant(i)" />
    }
  }
</div>
